import * as React from 'react';
import UiButton from '@/ui/UiButton/UiButton';
import { configListKeys } from './constants';
import styles from './ClientConfig.module.scss';
import UiInput from '@/ui/UiInput/Uiinput';
import { getClientConfig } from '@/hooks/helpers';

const ClientConfig = ({setIsConfigActive}: {setIsConfigActive: (isActive: boolean) => void}) => {
  const [clientConfig, setClientConfig] = React.useState<any>(() => {
    return getClientConfig();
  });
  const setAuthSDKConfig = () => {
    localStorage.setItem('AuthClientConfig', JSON.stringify(clientConfig));
    window.location.reload();
  }

  return (
    <div className={styles.client_config_wrapper}>
      <div className="page-title">
        Параметры SDK
      </div>
      <div className={styles.inputs_wrapper}>
        {
          configListKeys.map((i, index) => {
            return (
              <div className={styles.input_item} key={i} data-testid={i}>
                <UiInput
                  label={i}
                  value={clientConfig[i as keyof any] as string}
                  className={`index-element-${index + 1}`}
                  onChange={e => setClientConfig((prev: any) => ({
                    ...prev,
                    [i]: e.target.value,
                  }))}
                />
              </div>
            )
          })
        }
      </div>
      <UiButton
        className='index-element-8'
        dataTestId="apply-btn"
        onClick={() => setAuthSDKConfig()}
      >Применить параметры</UiButton>
      <UiButton
        type='flat'
        size='small'
        className='back-btn index-element-9'
        dataTestId="back-btn"
        onClick={() => setIsConfigActive(false)}
      >
        Назад
      </UiButton>
    </div>
  )
};

export default ClientConfig;